export function replaceString(txt: string) {
  const reg = new RegExp(/(\{\{(.*?)\}\})/g);
  return txt.match(reg);
}

export function replaceStringValue(value: string, data: { [key: string]: any }) {
  if (!value) return "";
  const mat = replaceString(value);
  if (!mat || !Array.isArray(mat) || mat.length == 0) {
    return value;
  }
  const getDataValue: Function = (d: { [key: string]: any }) => {
    if (!d) return "";
    if (!d.value) return "";
    if (typeof d.value == "string") {
      return d.value;
    } else {
      const childKeys = Object.keys(d.value);
      return childKeys.map(key => getDataValue(d.value[key])).join("");
    }
  };
  const result = mat.map(m => ({ key: m, cap: m.slice(2, -2)})).reduce((p, c) => {
    const keys = c.cap.split(".");
    const v = keys.reduce((p, k) => {
      if (p == null) return p;
      const r = p[k];
      return r;
    }, data);
    if (typeof v == "string") p = p.replace(c.key, v);
    else p = p.replace(c.key, "");
    return p;
  }, value);
  return result;
}